var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7769 4.227L11.1249 6.879M13.7769 4.227C12.511 2.96113 10.7941 2.25 9.00391 2.25C7.21369 2.25 5.49678 2.96113 4.23091 4.227M13.7769 4.227C15.0428 5.49287 15.7539 7.20979 15.7539 9C15.7539 9.88642 15.5793 10.7642 15.2401 11.5831C14.9009 12.4021 14.4037 13.1462 13.7769 13.773M11.1249 6.879C10.5623 6.31639 9.79956 6 9.00391 6C8.20826 6 7.44552 6.31639 6.88291 6.879M11.1249 6.879C11.6875 7.44161 12.0039 8.20435 12.0039 9C12.0039 9.79565 11.6875 10.5584 11.1249 11.121M11.1249 11.121L13.7769 13.773M11.1249 11.121C10.5623 11.6836 9.79956 12 9.00391 12C8.20826 12 7.44552 11.6836 6.88291 11.121M13.7769 13.773C13.1501 14.3998 12.406 14.897 11.587 15.2362C10.7681 15.5754 9.89033 15.75 9.00391 15.75C8.11748 15.75 7.23974 15.5754 6.42079 15.2362C5.60185 14.897 4.8577 14.3998 4.23091 13.773M6.88291 6.879L4.23091 4.227M6.88291 6.879C6.3203 7.44161 6.00391 8.20435 6.00391 9C6.00391 9.79565 6.3203 10.5584 6.88291 11.121M4.23091 4.227C2.96504 5.49287 2.25391 7.20979 2.25391 9C2.25391 9.88642 2.4285 10.7642 2.76772 11.5831C3.10694 12.4021 3.60411 13.1462 4.23091 13.773M6.88291 11.121L4.23091 13.773",
    stroke: "#3F3F46",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.395f1e7760a88ad2c92eaf536877ab54.svg";
export { ForwardRef as ReactComponent };